(() => {
// Xmas Weihnachts Seite
jQuery(document).ready(function($) {
    let image1 = document.querySelector(".star-1");
    let image2 = document.querySelector(".star-2");
    let image3 = document.querySelector(".star-3");
    let image4 = document.querySelector(".star-4");
    let image5 = document.querySelector(".star-5");
    const scrollTrackingTimeline = new ScrollTimeline({
        scource: document.scrollingElement,
        orientation: "block",
        scrollOffsets: [
            CSS.percent(0),
            CSS.percent(100)
        ]
    });
    image1?.animate({
        transform: [
            'rotate(15deg)',
            'rotate(350deg)'
        ]
    }, {
        duration: 1,
        timeline: scrollTrackingTimeline
    });
    image2?.animate({
        transform: [
            'rotate(360deg)',
            'rotate(10deg)'
        ]
    }, {
        duration: 1,
        timeline: scrollTrackingTimeline
    });
    image3?.animate({
        transform: [
            'rotate(45deg)',
            'rotate(240deg)'
        ]
    }, {
        duration: 1,
        timeline: scrollTrackingTimeline
    });
    image4?.animate({
        transform: [
            'rotate(320deg)',
            'rotate(25deg)'
        ]
    }, {
        duration: 1,
        timeline: scrollTrackingTimeline
    });
    image5?.animate({
        transform: [
            'rotate(45deg)',
            'rotate(350deg)'
        ]
    }, {
        duration: 1,
        timeline: scrollTrackingTimeline
    });
});
// PANELS
"use strict";
var $d0d5bb65810c4e51$var$panels = document.querySelectorAll(".panel");
function $d0d5bb65810c4e51$var$toggleOpen() {
    this.classList.toggle("open");
}
function $d0d5bb65810c4e51$var$toggleActive(e) {
    if (e.propertyName.indexOf("flex")) this.classList.toggle("open-active");
}
for(var $d0d5bb65810c4e51$var$i = 0; $d0d5bb65810c4e51$var$i < $d0d5bb65810c4e51$var$panels.length; $d0d5bb65810c4e51$var$i++)$d0d5bb65810c4e51$var$panels[$d0d5bb65810c4e51$var$i].addEventListener("click", $d0d5bb65810c4e51$var$toggleOpen);
for(var $d0d5bb65810c4e51$var$i = 0; $d0d5bb65810c4e51$var$i < $d0d5bb65810c4e51$var$panels.length; $d0d5bb65810c4e51$var$i++)$d0d5bb65810c4e51$var$panels[$d0d5bb65810c4e51$var$i].addEventListener("transitionend", $d0d5bb65810c4e51$var$toggleActive);
// for (var i = 0; i < panels.length; i++) {
//   var background = panels[i].dataset.background;
//   panels[i].style.backgroundImage = "url('".concat(background, "')");
// }
let $d0d5bb65810c4e51$var$observer = new IntersectionObserver((entries, observer)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            let lazyElement = entry.target;
            let actualImage = lazyElement.getAttribute('data-background');
            lazyElement.style.backgroundImage = `url(${actualImage})`;
            observer.unobserve(lazyElement);
        }
    });
});
document.querySelectorAll('.panel').forEach((element)=>{
    $d0d5bb65810c4e51$var$observer.observe(element);
});

})();
//# sourceMappingURL=xmas.js.map
